import React, {useState, useEffect, useRef} from 'react';
import {ADMIN_ROLE, CUSTOMER_ROLE, MANAGER_ROLE, GUEST_ROLE, errorCallback, makeUrl} from "../constant";
import { getFetchRequest, GET_USER_REQUEST, postFetchRequest, CHANGE_PASSWORD_REQUEST, REJECT_USER_REQUEST, UNREJECT_USER_REQUEST, deleteFetchRequest, GET_INFO_FTS, ADMIN_CREATE_CUSTOMER_USER, MAKE_CUSTOMER_REQUEST, CONFIGS_URL } from '../store/requests';
import { SelectManagerModal } from './selectManagerModal';
import { CheckIconThin } from '../appearence/icons/check_icon_thin';

const selectContent = [
    {
        name: 'менеджер', 
        value: MANAGER_ROLE,
        id: MANAGER_ROLE,
    },
    {
        name: 'покупатель', 
        value: CUSTOMER_ROLE,
        id: CUSTOMER_ROLE,
    },
    {
        name: 'администратор', 
        value: ADMIN_ROLE,
        id: ADMIN_ROLE,
    },
    {
        name: 'гость', 
        value: GUEST_ROLE,
        id: GUEST_ROLE,
    },
];

const getRoleNameByValue = (value) => {
    let result = '';
    selectContent.forEach(it => it.value === value ? result = it.name : null);
    return result;
};

const displayCoefficient = (value) => {
    if (value === undefined || value === null || value === '' || Number(value) === 0) return '';
    return String(value);
};

const normalizeCoefficient = (rawValue, allowEmpty) => {
    const value = String(rawValue ?? '').trim().replace(',', '.');
    if (!value) return allowEmpty ? '0' : null;
    if (!/^\d+(\.\d+)?$/.test(value)) return null;
    if (!allowEmpty && Number(value) === 0) return null;
    return value;
};

// Константы для вкладок
// Встроенные стили
const styles = {
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
    },
    modalContent: {
        background: 'white',
        borderRadius: '8px',
        maxWidth: '600px',
        width: '90%',
        maxHeight: '80vh',
        overflowY: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px',
        borderBottom: '1px solid #e0e0e0'
    },
    modalClose: {
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#666',
        padding: 0,
        width: '30px',
        height: '30px', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    modalBody: {
        padding: '20px'
    },
    userDetails: {
        marginBottom: '20px'
    },
    userCompanies: {
        marginBottom: '20px'
    },
    sectionTitle: {
        marginTop: 0,
        marginBottom: '15px',
        color: '#333',
        borderBottom: '1px solid #e0e0e0',
        paddingBottom: '8px'
    },
    detailText: {
        margin: '8px 0',
        color: '#666'
    },
    companyItem: {
        background: '#f8f9fa',
        padding: '15px',
        borderRadius: '6px',
        marginBottom: '15px'
    },
    statusApproved: {
        color: '#28a745',
        fontWeight: '500'
    },
    buttonSmall: {
        padding: '6px 12px',
        fontSize: '12px'
    },
    buttonDanger: {
        backgroundColor: '#dc3545',
        color: 'white',
        marginLeft: '8px'
    },
    coefficientRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginTop: '12px',
    },
    coefficientInput: {
        width: '100px',
        padding: '6px 10px',
        border: '1px solid #ccc',
        borderRadius: '6px',
        fontSize: '14px',
    },
    savedMark: {
        color: '#2E7D32',
        fontSize: '13px',
    },
    tableRowHover: {
        cursor: 'pointer'
    },
    hoverEffect: {
        ':hover': {
            backgroundColor: '#f8f9fa'
        }
    }
};

// Функция для определения статуса пользователя
const getUserStatus = (user) => {
    if (user.isRejected) {
        return 'rejected';
    }
    
    if (user.elsiRole === ADMIN_ROLE || user.elsiRole === MANAGER_ROLE) {
        return 'approved';
    }
    
    if (user.elsiRole === CUSTOMER_ROLE && user.isValid) {
        return 'approved';
    }
    
    // Гость с ИНН существующей компании (заявка по существующему ИНН)
    if (user.elsiRole === GUEST_ROLE && user.registrationTin) {
        return 'existing_inn';
    }

    // Гости и невалидированные клиенты
    return 'pending';
};

const CreateCustomerForm = ({ onCancel, onSuccess }) => {
    const [tin, setTin] = useState('');
    const [kpp, setKpp] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [legalAddress, setLegalAddress] = useState('');
    const [postalAddress, setPostalAddress] = useState('');
    const [representativeName, setRepresentativeName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [loadingFts, setLoadingFts] = useState(false);
    const [lastLoadedTin, setLastLoadedTin] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const legalAddressRef = useRef(null);
    const postalAddressRef = useRef(null);

    const autoResize = (el) => {
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    };

    // Авто-ресайз при автозаполнении из ФНС/Дадаты
    useEffect(() => {
        autoResize(legalAddressRef.current);
    }, [legalAddress]);

    useEffect(() => {
        autoResize(postalAddressRef.current);
    }, [postalAddress]);

    const loadByTinIfValid = (rawTin) => {
        const digits = (rawTin || '').replace(/\D/g, '');
        if (!digits || (digits.length !== 10 && digits.length !== 12)) {
            return;
        }
        if (digits === lastLoadedTin) {
            return;
        }
        setError('');
        setLoadingFts(true);
        setLastLoadedTin(digits);
        getFetchRequest(
            makeUrl([GET_INFO_FTS, digits, '/']),
            (data) => {
                // data приходит в формате CustomerSerializer: tin, kpp, name, legal_address, postalAddress
                setTin(data.tin || digits);
                setKpp(data.kpp || '');
                setCompanyName(data.name || '');
                setLegalAddress(data.legal_address || '');
                setPostalAddress(data.postalAddress || data.legal_address || '');
                setLoadingFts(false);
            },
            (err) => {
                errorCallback(err);
                setError('Не удалось получить данные по ИНН. Проверьте ИНН или попробуйте позже.');
                setLoadingFts(false);
            }
        );
    };

    const handleTinChange = (value) => {
        setTin(value);
        setError('');
        loadByTinIfValid(value);
    };

    const handleSave = () => {
        setError('');
        const trimmedTin = (tin || '').trim();
        const trimmedEmail = (email || '').trim();
        const trimmedPhone = (phone || '').trim();
        const trimmedRep = (representativeName || '').trim();
        const trimmedName = (companyName || '').trim();
        const trimmedLegal = (legalAddress || '').trim();

        if (!trimmedTin || !trimmedEmail || !trimmedPhone || !trimmedRep || !trimmedName || !trimmedLegal) {
            setError('Заполните обязательные поля: ИНН, КПП, Название, Представитель, Телефон, E-mail, Юр. адрес.');
            return;
        }

        const body = {
            email: trimmedEmail,
            phone: trimmedPhone,
            representativeName: trimmedRep,
            tin: trimmedTin,
            kpp: kpp || '',
            name: trimmedName,
            legalAddress: trimmedLegal,
            postalAddress: postalAddress || trimmedLegal,
        };

        setSaving(true);
        postFetchRequest(
            makeUrl([ADMIN_CREATE_CUSTOMER_USER]),
            body,
            (response) => {
                // успешный ответ 201 без JSON
                setSaving(false);
                if (onSuccess) {
                    onSuccess();
                }
            },
            (err) => {
                errorCallback(err);
                setError('Не удалось сохранить контрагента. Проверьте данные или попробуйте позже.');
                setSaving(false);
            },
            true
        );
    };

    return (
        <article className="users">
            <div className="order-detail-header">
                <button className="order-detail-back-btn" onClick={onCancel}>
                    <svg width="31" height="12" viewBox="0 0 31 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.219667 4.99262C-0.073225 5.28551 -0.073225 5.76039 0.219667 6.05328L4.99264 10.8263C5.28553 11.1191 5.76041 11.1191 6.0533 10.8263C6.34619 10.5334 6.34619 10.0585 6.0533 9.76559L1.81066 5.52295L6.0533 1.28031C6.34619 0.987415 6.34619 0.512542 6.0533 0.219648C5.76041 -0.073245 5.28553 -0.073245 4.99264 0.219648L0.219667 4.99262ZM30.75 5.52295V4.77295L0.749998 4.77295V5.52295V6.27295L30.75 6.27295V5.52295Z" fill="#666666"/>
                    </svg>
                    Назад
                </button>
            </div>
            <h2 className="clients-toolbar__title">Регистрация нового клиента</h2>
            <div className="create-customer-form">
                <div className="create-customer-form__row">
                    <div className="create-customer-form__field">
                        <label>ИНН</label>
                        <input
                            type="text"
                            value={tin}
                            onChange={(e) => handleTinChange(e.target.value)}
                        />
                        {loadingFts && (
                            <div className="create-customer-form__hint">
                                Загрузка данных по ИНН...
                            </div>
                        )}
                    </div>
                    <div className="create-customer-form__field">
                        <label>КПП</label>
                        <input
                            type="text"
                            value={kpp}
                            onChange={(e) => setKpp(e.target.value)}
                        />
                    </div>
                </div>

                <div className="create-customer-form__row">
                    <div className="create-customer-form__field">
                        <label>Название</label>
                        <input
                            type="text"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                        />
                    </div>

                    <div className="create-customer-form__field">
                        <label>Представитель организации</label>
                        <input
                            type="text"
                            value={representativeName}
                            onChange={(e) => setRepresentativeName(e.target.value)}
                        />
                    </div>
                </div>

                <div className="create-customer-form__row">  
                    <div className="create-customer-form__field">
                        <label>Телефон</label>
                        <input
                            type="text"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                    </div>
                    <div className="create-customer-form__field">
                        <label>Электронная почта</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                </div>

                <div className="create-customer-form__row">      
                    <div className="create-customer-form__field">
                        <label>Юридический адрес</label>
                        <textarea
                            ref={legalAddressRef}
                            rows={3}
                            value={legalAddress}
                            onChange={(e) => {
                                setLegalAddress(e.target.value);
                                autoResize(e.target);
                            }}
                        />
                    </div>

                    <div className="create-customer-form__field">
                        <label>Адрес грузополучателя</label>
                        <textarea
                            ref={postalAddressRef}
                            rows={3}
                            value={postalAddress}
                            onChange={(e) => {
                                setPostalAddress(e.target.value);
                                autoResize(e.target);
                            }}
                        />
                    </div>
                </div>          
                

                {error && (
                    <div className="create-customer-form__error">
                        {error}
                    </div>
                )}

                <div className="create-customer-form__actions">
                    <button
                        type="button"
                        className="button button-secondary"
                        onClick={onCancel}
                        disabled={saving}
                    >
                        Отменить
                    </button>
                    <button
                        type="button"
                        className="button"
                        onClick={handleSave}
                        disabled={saving}
                    >
                        {saving ? 'Сохранение...' : 'Сохранить'}
                    </button>
                </div>
            </div>
        </article>
    );
};

const isStaffUser = (user) => user.elsiRole === ADMIN_ROLE || user.elsiRole === MANAGER_ROLE;

const MainPageContentNew = ({ isCollapsed, mode = 'counterparties' }) => {
    const isAdministration = mode === 'administration';
    const [users, setUsers] = useState([]);
    const [managersList, setManagersLists] = useState([]);
    const [validatedUser, setValidatedUser] = useState({});
    const [selectManagerModalIsOpen, setSelectManagerModalIsOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userDetailsModalOpen, setUserDetailsModalOpen] = useState(false);
    const [userCompanies, setUserCompanies] = useState([]);
    const [userCustomerInfo, setUserCustomerInfo] = useState({});
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [deleteError, setDeleteError] = useState('');
    const [isCreateCustomerMode, setIsCreateCustomerMode] = useState(false);
    const [coefficientDraft, setCoefficientDraft] = useState('');
    const [coefficientCustomerId, setCoefficientCustomerId] = useState(null);
    const [coefficientSaved, setCoefficientSaved] = useState(false);
    const [companiesLoaded, setCompaniesLoaded] = useState(false);
    const [defaultCoefficient, setDefaultCoefficient] = useState('');
    const [defaultCoefficientId, setDefaultCoefficientId] = useState(null);
    const [defaultCoefficientActive, setDefaultCoefficientActive] = useState(true);
    const [defaultCoefficientSaved, setDefaultCoefficientSaved] = useState(false);
    const coefficientTimer = useRef(null);
    const defaultCoefficientTimer = useRef(null);

    const succesLoadUserCallback = (response) => {
        setUsers(response);
        if (!isAdministration) {
            loadCustomersForUsers((response || []).filter((user) => !isStaffUser(user)));
        }
    };

    const succesLoadManagersListCallback = (response) => {
        setManagersLists(response);
    }

    const succesValidateUserCallback = (response) => {
        if(response.status === 200) {
            loadUsers();
        }
    };

    const successMakeManagerCallback = (response) => {
        if(response.status === 200) {
            loadUsers();
            closeUserDetailsModal();
        }
    };

    const successRejectUserCallback = (response) => {
        if(response.status === 200) {
            loadUsers();
        }
    };

    const successUnrejectUserCallback = (response) => {
        if(response.status === 200) {
            loadUsers();
        }
    };

    const successLoadUserCompaniesCallback = (companies) => {
        const list = companies || [];
        setUserCompanies(list);
        setCompaniesLoaded(true);
        const company = list.find((item) => item.isDefault) || list[0];
        setCoefficientCustomerId(company?.id || null);
        setCoefficientDraft(displayCoefficient(company?.priceCoefficient));
        setCoefficientSaved(false);
    };

    const loadCustomersForUsers = (usersList = []) => {
        usersList.forEach((user) => {
            if (!user || !user.id) return;
            // Не перезагружаем, если уже есть данные
            if (userCustomerInfo[user.id]) return;
            getFetchRequest(
                makeUrl([GET_USER_REQUEST, user.id, '/customer/']),
                (companies) => {
                    if (!companies || !companies.length) return;
                    const defaultCompany = companies.find((c) => c.isDefault) || companies[0];
                    setUserCustomerInfo((prev) => ({
                        ...prev,
                        [user.id]: {
                            tin: defaultCompany?.tin || '—',
                            companyName: defaultCompany?.name || user.name || '—',
                            priceCoefficient: defaultCompany?.priceCoefficient,
                        },
                    }));
                },
                errorCallback
            );
        });
    };

    const loadUsers = () => {
        getFetchRequest(makeUrl([GET_USER_REQUEST]), succesLoadUserCallback, errorCallback);
    };

    useEffect(() => {
        loadUsers();
    }, []);

    useEffect(() => {
        if (isAdministration) return;
        getFetchRequest(makeUrl([CONFIGS_URL]), (configs) => {
            const item = (configs || []).find((config) => config.configName === 'default-customer-coefficient');
            if (!item) return;
            setDefaultCoefficient(item.configValue ?? '');
            setDefaultCoefficientId(item.id);
            setDefaultCoefficientActive(item.isActive !== false);
        }, errorCallback);
    }, [isAdministration]);

    const handleSelectManager = (e, id) => {
        e.stopPropagation();
        getFetchRequest(makeUrl([GET_USER_REQUEST, 'search/?elsiRole='+MANAGER_ROLE]), succesLoadManagersListCallback, errorCallback);
        setValidatedUser({id, managerId:''});
        setSelectManagerModalIsOpen(true);
    };

    const handleValidateUser = () => {
        setSelectManagerModalIsOpen(false);
        const usersCopy = [...users];
        usersCopy.forEach(it => {
            if(it.id === validatedUser.id) {
                if(validatedUser.id && validatedUser.managerId) {
                    const data = {managerId: validatedUser.managerId};
                    postFetchRequest(makeUrl([GET_USER_REQUEST, validatedUser.id, `/validate/`]), data, succesValidateUserCallback, errorCallback, true);
                    setValidatedUser({});
                }
            }
        });
    };

    const handleRejectUser = (e, userId) => {
        e.stopPropagation();
        const data = {};
        postFetchRequest(makeUrl([REJECT_USER_REQUEST, userId, '/reject/']), data, successRejectUserCallback, errorCallback, true);
    };

    const handleUnrejectUser = (e, userId) => {
        e.stopPropagation();
        const data = {};
        postFetchRequest(makeUrl([UNREJECT_USER_REQUEST, userId, '/unreject/']), data, successUnrejectUserCallback, errorCallback, true);
    };

    const handleDeleteClick = (e, user) => {
        e.stopPropagation();
        setUserToDelete(user);
        setDeleteError('');
        setDeleteModalOpen(true);
    };

    const handleConfirmDelete = () => {
        if (!userToDelete?.id) {
            setDeleteModalOpen(false);
            return;
        }
        setDeleteError('');
        deleteFetchRequest(
            makeUrl([GET_USER_REQUEST, userToDelete.id, '/']),
            () => {
                setDeleteModalOpen(false);
                setUserToDelete(null);
                setDeleteError('');
                loadUsers();
            },
            (err) => {
                console.error(err);
                setDeleteError('Не удалось удалить клиента. Попробуйте позже.');
            }
        );
    };

    const handleCancelDelete = () => {
        setDeleteModalOpen(false);
        setUserToDelete(null);
        setDeleteError('');
    };

    const handleCloseModal = (e) => {
        e.stopPropagation();
        setSelectManagerModalIsOpen(false);
        setValidatedUser({});
    };

    const handleUserClick = (user) => {
        setSelectedUser(user);
        setCompaniesLoaded(false);
        setCoefficientDraft('');
        setCoefficientCustomerId(null);
        setCoefficientSaved(false);
        getFetchRequest(makeUrl([GET_USER_REQUEST, user.id, '/customer/']), successLoadUserCompaniesCallback, errorCallback);
        setUserDetailsModalOpen(true);
    };

    const closeUserDetailsModal = () => {
        setUserDetailsModalOpen(false);
        setSelectedUser(null);
        setUserCompanies([]);
        setCompaniesLoaded(false);
        setCoefficientDraft('');
        setCoefficientCustomerId(null);
        setCoefficientSaved(false);
    };

    const handleCoefficientChange = (event) => {
        const value = event.target.value.replace(',', '.');
        if (value !== '' && !/^\d*\.?\d*$/.test(value)) return;
        setCoefficientDraft(value);
        setCoefficientSaved(false);
        if (coefficientTimer.current) clearTimeout(coefficientTimer.current);
        const customerId = coefficientCustomerId;
        const userId = selectedUser?.id;
        coefficientTimer.current = setTimeout(() => {
            const normalized = normalizeCoefficient(value, true);
            if (normalized === null || !customerId) return;
            postFetchRequest(
                makeUrl([MAKE_CUSTOMER_REQUEST, customerId, '/']),
                { priceCoefficient: normalized },
                () => {
                    setCoefficientSaved(true);
                    if (userId) {
                        setUserCustomerInfo((prev) => ({
                            ...prev,
                            [userId]: {
                                ...(prev[userId] || {}),
                                priceCoefficient: normalized === '0' ? '' : normalized,
                            },
                        }));
                    }
                },
                errorCallback,
                true,
            );
        }, 600);
    };

    const handleDefaultCoefficientChange = (event) => {
        const value = event.target.value.replace(',', '.');
        if (value !== '' && !/^\d*\.?\d*$/.test(value)) return;
        setDefaultCoefficient(value);
        setDefaultCoefficientSaved(false);
        if (defaultCoefficientTimer.current) clearTimeout(defaultCoefficientTimer.current);
        const configId = defaultCoefficientId;
        const isActive = defaultCoefficientActive;
        defaultCoefficientTimer.current = setTimeout(() => {
            const normalized = normalizeCoefficient(value, false);
            if (normalized === null || !configId) return;
            postFetchRequest(
                makeUrl([CONFIGS_URL, configId, '/']),
                { configValue: normalized, isActive },
                () => setDefaultCoefficientSaved(true),
                errorCallback,
                true,
            );
        }, 600);
    };

    const succesPasswordResetCallback = (response) => {
        console.log(response);
    };

    const handleSendResetPasswordRequest = (e, email) => {
        e.stopPropagation();
        if(email) {
            const data = {email};
            postFetchRequest(makeUrl([CHANGE_PASSWORD_REQUEST]), data, succesPasswordResetCallback, errorCallback, true);
        }
    };

    const getStatusLabel = (status) => {
        if (status === 'approved') return 'Активный';
        if (status === 'pending') return 'Ожидает';
        if (status === 'existing_inn') return 'ИНН уже существует';
        return 'Заблокирован';
    };

    const getStatusClass = (status) => {
        if (status === 'approved') return 'clients-table__status--active';
        if (status === 'rejected') return 'clients-table__status--blocked';
        if (status === 'existing_inn') return 'clients-table__status--pending';
        return '';
    };

    const getClientName = (user) => {
        const cached = userCustomerInfo[user.id];
        return cached?.companyName || user.companyName || user.organizationName || user.customerName || user.name || '—';
    };

    const getClientTin = (user) => {
        const cached = userCustomerInfo[user.id];
        return cached?.tin || user.companyTin || user.tin || user.inn || (user.customer && user.customer.tin) || '—';
    };

    const getPriceCoefficient = (user) => {
        const cached = userCustomerInfo[user.id];
        if (cached && cached.priceCoefficient !== undefined && cached.priceCoefficient !== null) {
            return displayCoefficient(cached.priceCoefficient) || '—';
        }
        const fallback = user.priceCoefficient ?? user.priceCoef ?? '';
        return displayCoefficient(fallback) || '—';
    };

    const handleApproveUser = (user) => {
        const fakeEvent = { stopPropagation: () => {} };
        if (getUserStatus(user) === 'rejected') {
            handleUnrejectUser(fakeEvent, user.id);
        }
        handleSelectManager(fakeEvent, user.id);
    };

    const handleBlockUser = (user) => {
        const fakeEvent = { stopPropagation: () => {} };
        handleRejectUser(fakeEvent, user.id);
    };

    const handleAccessSwitch = (e, user, targetStatus) => {
        e.stopPropagation();
        const currentStatus = getUserStatus(user);
        if (currentStatus === targetStatus) {
            return;
        }

        if (targetStatus === 'approved') {
            handleApproveUser(user);
            return;
        }

        if (targetStatus === 'rejected') {
            handleBlockUser(user);
            return;
        }
        // pending — только отображение
    };

    const getSwitchStateClass = (status) => {
        if (status === 'approved') return 'tristate-switch--approved';
        if (status === 'rejected') return 'tristate-switch--blocked';
        return 'tristate-switch--pending';
    };

    const visibleUsers = users.filter((user) => (
        isAdministration ? isStaffUser(user) : !isStaffUser(user)
    ));

    const renderUserRow = (user, index) => {
        const status = getUserStatus(user);

        return (
            <div
                key={user.id || index}
                className="clients-table__row"
                onClick={() => handleUserClick(user)}
            >
                <div className="clients-table__cell clients-table__cell--id">{index + 1}</div>
                {isAdministration ? (
                    <>
                        <div className="clients-table__cell">{user.name || '—'}</div>
                        <div className="clients-table__cell">{user.phone || '—'}</div>
                        <div className="clients-table__cell">{user.email || '—'}</div>
                        <div className="clients-table__cell">{getRoleNameByValue(user.elsiRole) || '—'}</div>
                    </>
                ) : (
                    <>
                        <div className="clients-table__cell">{getClientName(user)}</div>
                        <div className="clients-table__cell">{getClientTin(user)}</div>
                        <div className="clients-table__cell">{user.name || '—'}</div>
                        <div className="clients-table__cell">{user.phone || '—'}</div>
                        <div className="clients-table__cell">{user.email || '—'}</div>
                        <div className="clients-table__cell">{getPriceCoefficient(user)}</div>
                    </>
                )}
                <div className="clients-table__cell" onClick={(e) => e.stopPropagation()}>
                    <div className={`tristate-switch ${getSwitchStateClass(status)}`} role="group" aria-label="Статус доступа">
                        <button
                            type="button"
                            className={`tristate-switch__segment ${status === 'rejected' ? 'tristate-switch__segment--active' : ''}`}
                            onClick={(e) => handleAccessSwitch(e, user, 'rejected')}
                            aria-label="Заблокирован"
                        >
                            <span></span>
                        </button>
                        <button
                            type="button"
                            className={`tristate-switch__segment ${status === 'pending' ? 'tristate-switch__segment--active' : ''}`}
                            onClick={(e) => handleAccessSwitch(e, user, 'pending')}
                            aria-label="Ожидает"
                        >
                            <span></span>
                        </button>
                        <button
                            type="button"
                            className={`tristate-switch__segment ${status === 'approved' ? 'tristate-switch__segment--active' : ''}`}
                            onClick={(e) => handleAccessSwitch(e, user, 'approved')}
                            aria-label="Активен"
                        >
                            <span></span>
                        </button>
                        <div className="tristate-switch__thumb" />
                    </div>
                </div>
                <div className={`clients-table__cell clients-table__status ${getStatusClass(status)}`}>
                    {getStatusLabel(status)}
                </div>
                <div className="clients-table__cell clients-table__actions" onClick={(e) => e.stopPropagation()}>
                    <button
                        type="button"
                        className="clients-table__delete-btn"
                        aria-label={isAdministration ? 'Удалить пользователя' : 'Удалить клиента'}
                        onClick={(e) => handleDeleteClick(e, user)}
                    >
                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.849609 0.850098L7.84961 7.8501" stroke="#222222" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M7.84961 0.850098L0.849609 7.8501" stroke="#222222" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>
        );
    };

    return (
        <>
            {selectManagerModalIsOpen && 
                <SelectManagerModal 
                    managersList={managersList} 
                    validatedUser={validatedUser} 
                    setValidatedUser={setValidatedUser} 
                    handleValidateUser={handleValidateUser}
                />
            }
            
            {userDetailsModalOpen && selectedUser && (
                <div style={styles.modalOverlay} onClick={closeUserDetailsModal}>
                    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3>Детали пользователя</h3>
                            <button style={styles.modalClose} onClick={closeUserDetailsModal}>×</button>
                        </div>
                        <div style={styles.modalBody}>
                            <div style={styles.userDetails}>
                                <h4 style={styles.sectionTitle}>Информация о пользователе</h4>
                                <p style={styles.detailText}><strong>Имя:</strong> {selectedUser.name}</p>
                                <p style={styles.detailText}><strong>Email:</strong> {selectedUser.email}</p>
                                <p style={styles.detailText}><strong>Телефон:</strong> {selectedUser.phone}</p>
                                <p style={styles.detailText}><strong>Роль:</strong> {getRoleNameByValue(selectedUser.elsiRole)}</p>
                                <p style={styles.detailText}><strong>Статус:</strong> {selectedUser.isValid ? 'Валидирован' : 'Не валидирован'}</p>
                                <p style={styles.detailText}><strong>Отклонен:</strong> {selectedUser.isRejected ? 'Да' : 'Нет'}</p>
                                <div style={styles.coefficientRow}>
                                    <strong>Ценовой коэффициент</strong>
                                    <input
                                        style={styles.coefficientInput}
                                        type="text"
                                        inputMode="decimal"
                                        value={coefficientDraft}
                                        placeholder="общий"
                                        disabled={!coefficientCustomerId}
                                        onChange={handleCoefficientChange}
                                    />
                                    {coefficientSaved && <span style={styles.savedMark}>сохранено</span>}
                                </div>
                                {companiesLoaded && !coefficientCustomerId && (
                                    <p style={styles.detailText}>У пользователя нет компании, личный коэффициент задать нельзя.</p>
                                )}
                                {selectedUser.elsiRole !== MANAGER_ROLE && (
                                    <button 
                                        className="button"
                                        style={{...styles.buttonSmall, marginTop: '8px'}}
                                        onClick={(e)=>{
                                            e.stopPropagation();
                                            postFetchRequest(
                                                makeUrl([GET_USER_REQUEST, selectedUser.id, '/make_manager/']),
                                                {},
                                                successMakeManagerCallback,
                                                errorCallback,
                                                true
                                            );
                                        }}
                                    >
                                        Сделать менеджером
                                    </button>
                                )}
                            </div>
                            
                            {userCompanies && userCompanies.length > 0 && (
                                <div style={styles.userCompanies}>
                                    <h4 style={styles.sectionTitle}>Компании пользователя</h4>
                                    {userCompanies.map((company, index) => (
                                        <div key={index} style={styles.companyItem}>
                                            <p style={styles.detailText}><strong>Название:</strong> {company.name}</p>
                                            <p style={styles.detailText}><strong>ИНН:</strong> {company.tin}</p>
                                            <p style={styles.detailText}><strong>КПП:</strong> {company.kpp}</p>
                                            <p style={styles.detailText}><strong>Адрес:</strong> {company.legalAddress}</p>
                                            <p style={styles.detailText}><strong>По умолчанию:</strong> {company.isDefault ? 'Да' : 'Нет'}</p>
                                            <hr />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {deleteModalOpen && (
                <div style={styles.modalOverlay} onClick={handleCancelDelete}>
                    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3>{isAdministration ? 'Удалить пользователя' : 'Удалить клиента'}</h3>
                            <button style={styles.modalClose} onClick={handleCancelDelete}>×</button>
                        </div>
                        <div style={{ ...styles.modalBody, display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <p>Вы действительно хотите удалить {isAdministration ? 'пользователя' : 'клиента'} <strong>{userToDelete?.name || userToDelete?.email || 'без имени'}</strong>?</p>
                            {deleteError && (
                                <p style={{ color: '#dc3545', margin: 0 }}>{deleteError}</p>
                            )}
                            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                                <button className="button button-secondary" onClick={handleCancelDelete}>Отмена</button>
                                <button className="button button-danger" onClick={handleConfirmDelete}>Удалить</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            <section className={`workspace ${isCollapsed===null ? '': isCollapsed? 'workspace_collapsed' : 'workspace_full-width'} workspace__main`} 
                onClick={(e) => handleCloseModal(e)}>
                
                {isCreateCustomerMode && !isAdministration ? (
                    <CreateCustomerForm
                        onCancel={() => setIsCreateCustomerMode(false)}
                        onSuccess={() => {
                            setIsCreateCustomerMode(false);
                            loadUsers();
                        }}
                    />
                ) : (
                    <article className="users">
                        <div className="clients-toolbar">
                            {!isAdministration && (
                                <button
                                    type="button"
                                    className="clients-toolbar__create"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsCreateCustomerMode(true);
                                    }}
                                >
                                    Создать контрагента +
                                </button>
                            )}
                            
                            <div className="clients-toolbar__search">
                                <input type="text" placeholder="Поиск ...." />
                                <svg className="clients-toolbar__search-icon" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.7938 14.6615C14.6355 14.6615 17.7498 11.5473 17.7498 7.70574C17.7498 3.86419 14.6355 0.75 10.7938 0.75C6.95218 0.75 3.83789 3.86419 3.83789 7.70574C3.83789 11.5473 6.95218 14.6615 10.7938 14.6615Z" stroke="#1C1C1C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5.87594 12.6245L0.75 17.7503" stroke="#1C1C1C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>

                            </div>

                            {!isAdministration && (
                                <label className="clients-toolbar__coefficient">
                                    Стартовый коэффициент:
                                    <input
                                        type="text"
                                        inputMode="decimal"
                                        value={defaultCoefficient}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={handleDefaultCoefficientChange}
                                    />
                                    {defaultCoefficientSaved && <span className="clients-toolbar__coefficient-saved">сохранено</span>}
                                </label>
                            )}
                        </div>
                        <div className={`clients-table${isAdministration ? ' clients-table--administration' : ''}`}>
                            <div className="clients-table__header">
                                <div className="clients-table__row">
                                    <div className="clients-table__cell clients-table__cell--id">№</div>
                                    {isAdministration ? (
                                        <>
                                            <div className="clients-table__cell">Имя</div>
                                            <div className="clients-table__cell">Телефон</div>
                                            <div className="clients-table__cell">Электронная почта</div>
                                            <div className="clients-table__cell">Роль</div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="clients-table__cell">Клиент</div>
                                            <div className="clients-table__cell">ИНН организации</div>
                                            <div className="clients-table__cell">Представитель организации</div>
                                            <div className="clients-table__cell">Телефон</div>
                                            <div className="clients-table__cell">Электронная почта</div>
                                            <div className="clients-table__cell">Ценовой коэффициент</div>
                                        </>
                                    )}
                                    <div className="clients-table__cell clients-table__cell--lock">Доступ</div>
                                    <div className="clients-table__cell clients-table__cell--state">Статус</div>
                                    <div className="clients-table__cell"></div>
                                </div>
                            </div>
                            <div className="clients-table__body">
                                {visibleUsers.map(renderUserRow)}
                            </div>
                        </div>
                    </article>
                )}
            </section>
        </>
    );
};

export default MainPageContentNew;